import type { SVGProps } from 'react';
const SvgBillingSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#billing-sidebar_svg__a)">
      <path
        fill="currentColor"
        fillOpacity={0.88}
        d="M8 0a8 8 0 1 0 .001 16.001A8 8 0 0 0 8 0m0 14.643A6.644 6.644 0 0 1 8 1.357a6.644 6.644 0 0 1 0 13.286m.852-7.057-.454-.106V5.082c.679.093 1.098.518 1.17 1.04.009.07.07.123.14.123h.803c.084 0 .15-.074.143-.157-.11-1.113-1.025-1.827-2.249-1.95v-.584a.143.143 0 0 0-.143-.143h-.501a.143.143 0 0 0-.143.143v.589c-1.264.123-2.254.821-2.254 2.125 0 1.207.89 1.79 1.824 2.012l.44.113v2.548c-.789-.105-1.232-.527-1.323-1.095a.14.14 0 0 0-.14-.117h-.826a.143.143 0 0 0-.143.155c.08.982.825 1.886 2.415 2.002v.56c0 .079.064.143.143.143h.507a.144.144 0 0 0 .143-.144l-.004-.566c1.398-.124 2.398-.872 2.398-2.215-.002-1.239-.79-1.793-1.946-2.078m-1.225-.29a3 3 0 0 1-.268-.089c-.604-.218-.884-.57-.884-1.023 0-.648.491-1.018 1.152-1.102zm.771 3.65V8.56q.082.024.157.04c.845.256 1.129.614 1.129 1.162 0 .698-.525 1.118-1.286 1.185"
      />
    </g>
    <defs>
      <clipPath id="billing-sidebar_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBillingSidebar;
